export default __webpack_public_path__ + "static/media/hks1.a03a966b.jpg";